import { useField } from 'react-final-form';

import { t } from '../../../../../shared/components/l10n/l10n';
import { InvoicingMessage, InvoicingMessageType, SendByType } from '../../invoices/book-and-send/types';
import {
    useEmailOptionsPdfSelected,
    useEmailOptionsRecipientsSelected,
    useEmailOptionsOioSelected,
    useEInvoiceOptionsCorrectGlnNumber,
    useEInvoiceOptionsCorrectCvrNumber,
    useEInvoiceOptionsCorrectPNumber,
    useEInvoiceOptionsContactSelected,
} from '../../invoices/utils';

export function useRequiredFieldsValidation(): InvoicingMessage[] {
    const requiredFieldsMessages: InvoicingMessage[] = [];
    // check if email options make sense for sending order.
    const isPdfSelected = useEmailOptionsPdfSelected();
    const isOioSelected = useEmailOptionsOioSelected();
    const correctGlnNumberSelected = useEInvoiceOptionsCorrectGlnNumber();
    const correctCvrNumberSelected = useEInvoiceOptionsCorrectCvrNumber();
    const correctPNumberSelected = useEInvoiceOptionsCorrectPNumber();
    const isContactSelected = useEInvoiceOptionsContactSelected();
    // check if at least one recipient fields is entered
    const isRecipientSelected = useEmailOptionsRecipientsSelected();
    const {
        input: { value: sendByType },
    } = useField('sendByType');

    if (sendByType === SendByType.email) {
        if (!isPdfSelected && !isOioSelected) {
            requiredFieldsMessages.push({
                message: t`FORM_BOOKANDSEND_SELECT_ATTACHMENT_ERROR`,
                type: InvoicingMessageType.Error,
            });
        }

        if (!isRecipientSelected) {
            requiredFieldsMessages.push({
                message: t`FORM_BOOKANDSEND_SELECT_EMAIL_RECIPIENT_ERROR`,
                type: InvoicingMessageType.Error,
            });
        }
    }

    if (sendByType === SendByType.oioxml) {
        if (!correctGlnNumberSelected) {
            requiredFieldsMessages.push({
                message: t`MISSING_GLN`,
                type: InvoicingMessageType.Error,
            });
        }

        if (!correctCvrNumberSelected) {
            requiredFieldsMessages.push({
                message: t`MISSING_CVR`,
                type: InvoicingMessageType.Error,
            });
        }

        if (!correctPNumberSelected) {
            requiredFieldsMessages.push({
                message: t`MISSING_PNUMBER`,
                type: InvoicingMessageType.Error,
            });
        }

        if (!isContactSelected) {
            requiredFieldsMessages.push({
                message: t`FORM_BOOKANDSEND_EINVOICE_OPTIONS_ERROR_YOURREF_OR_ATTENTIONREF`,
                type: InvoicingMessageType.Error,
            });
        }
    }

    return requiredFieldsMessages;
}
